// extracted by mini-css-extract-plugin
export default {"container":"errorBoundaryFallback_container__6jFII","message":"errorBoundaryFallback_message__DtelH"};